// app 内嵌页面时，上报到 tiktok 的埋点
import jsbridge from '@bridge/bytedance-ad';

export function reportTT() {
  try {
    if (process.env.NODE_ENV === 'production') {
      jsbridge.call('adInfo', {}, (adInfo) => {
        if (adInfo && adInfo.log_extra) {
          jsbridge.call('sendLogV3', {
            eventName: 'landing_perf_stats',
            params: {
              category: 'event_v3',
              tag: 'landing_ad',
              refer: 'landing_page',
              nt: 4,
              is_ad_event: 1,
              pv: 1,
              index: 2,
              log_extra: adInfo.log_extra,
              value: adInfo.cid,
              ad_extra_data: JSON.stringify({ pv: 1, index: 2 }),
            }
          })
        }
      });
    }
  } catch (err) {
    console.log(err);
  }
}

// 自定义上报 tt pixel
export const customReportTTPixel = ({id, type, params}) => {
  try {
    ttq?.instance(id).track(type, params)
  } catch (err) {
    console.log(err);
  }
}
